// +++++++++++++++++++++
// Helper Functions
// +++++++++++++++++++++

var throttle = function (delay, fn) {
  var last = 0

  return function () {
    var now = Date.now()

    if (now - last >= delay) {
      last = now
      return fn.apply(this, arguments)
    }
  }
}

// +++++++++++++++++++++
// Accordion + FAQ
// +++++++++++++++++++++
var accordion = (function () {
  var settings = {
    title: '.js-accordion-title',
    content: '.js-accordion-content',
    accordionContainer: '.js-accordion',
    accordionGroup: '.js-accordion-group',
    mainSection: '.js-main-section',
    activeClass: 'active',
    filter: '#filter',
  }

  var init = function () {
    if ($(settings.title).length === 0) return

    initializeEventListeners()
  }

  var initializeEventListeners = function () {
    $(settings.title).on('click', togglePanel)
    $(settings.filter).on('keyup', throttle(200, filterFAQs))
  }

  var filterFAQs = function () {
    var filter = $(this).val()

    $(settings.mainSection).each(function (index, section) {
      // Loop through the sections
      var count = 0
      $(section)
        .find(settings.accordionGroup)
        .each(function (index, group) {
          // Loop through the FAQS
          var val = '^(?=.*\\b' + $.trim(filter).split(/\s+/).join('\\b)(?=.*\\b') + ').*$',
            reg = RegExp(val, 'i'),
            text = $(this).text().replace(/\s+/g, ' '),
            kps = $(this).data('keyphrase')

          // If the list item does not contain the text phrase fade it out
          if (!reg.test(text) && !reg.test(kps)) {
            $(this).hide()
            // Show the list item if the phrase matches and increase the count by 1
          } else {
            $(this).show()
            count++
          }
        })

      if (count > 0) {
        $(section).show()
      } else {
        $(section).hide()
      }
    })
  }

  var togglePanel = function () {
    var $container = $(this).parents(settings.accordionContainer)
    var $currentTitle = $(this).find('a')
    var $currentContent = $(this).next(settings.content)

    if ($currentTitle.attr('aria-expanded') == 'false') {
      var $activeTitle = $container.find('[aria-expanded=true]')
      var $activeContent = $container.find('[aria-hidden=false]')

      // closes any active titles
      $activeTitle.attr('aria-expanded', false).removeClass(settings.activeClass)
      // closes any active content
      $activeContent.slideUp(200).attr('aria-hidden', 'true')

      // opens new content
      $currentTitle.attr('aria-expanded', true).addClass('active')
      $currentContent.slideDown(200).attr('aria-hidden', 'false')

      var id = $(this).parent().attr('id')

      if (id) {
        // @arren
        // location.hash = "#" + id;
        // history.pushState(null, null, '#' + id);
      }
    } else {
      // close the clicked content
      $currentTitle.attr('aria-expanded', false).removeClass('active')
      $currentContent.slideUp(200).attr('aria-hidden', 'true')
    }
    // No Boing Boing
    return false
  }

  return {
    init: init,
  }
})()

// AA Animation Module
// Use for adding animations on page scroll / element in view

var animations = (function () {
  var classes = {
    willAnimate: '.will-animate',
    isAnimating: 'animate',
  }

  var observeAnimations = function (entries, observer) {
    entries.forEach((entry) => {
      let $target = $(entry.target)
      if (!$target.hasClass(classes.isAnimating) && entry.isIntersecting) {
        let delay = $target.data('delay')
        if (delay) {
          setTimeout(function () {
            $target.addClass(classes.isAnimating)
          }, parseInt(delay))
        } else {
          $target.addClass(classes.isAnimating)
        }
      }
    })
  }

  var initializeAnimationsObserver = function () {
    if (typeof IntersectionObserver === 'function') {
      let options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.05,
      }

      let observer = new IntersectionObserver(observeAnimations, options)

      let $targets = $(classes.willAnimate)

      $targets.each(function (index, target) {
        observer.observe(target)
      })
    } else {
      let $targets = $(classes.willAnimate).addClass(classes.isAnimating)
    }
  }

  var init = function () {
    if ($(classes.willAnimate).length === 0) {
      return
    }

    initializeAnimationsObserver()
  }

  return {
    init: init,
  }
})()

var sidebarPage = (function () {
  var settings = {
    sidebarLink: '.js-sidebar-link',
    mainSection: '.js-main-section',
  }

  var linkWasClicked = false

  var init = function () {
    if ($(settings.sidebarLink).length === 0) return

    initializeEventListeners()
    loadSectionFromHash()
  }

  var initializeEventListeners = function () {
    $(settings.sidebarLink).on('click', handleTabClick)
    $(window).on('scroll', throttle(300, toggleActiveLink))
  }

  var toggleActiveLink = function (e) {
    var activeSection

    if (!linkWasClicked) {
      $(settings.mainSection).each(function (index, element) {
        var position = element.getBoundingClientRect()
        var height = element.offsetHeight
        var offset = window.screen.height

        // elementY < windowHeight - 150) && (elementY >= -10

        if (position.top > 100 - height && position.bottom - height < offset && !activeSection) {
          activeSection = element
        }
      })

      if (activeSection) {
        var section = $(activeSection).data('section')

        var $activeLink = $(settings.sidebarLink + '[data-section="' + section + '"]')

        $activeLink.addClass('active')
        $(settings.sidebarLink).not($activeLink).removeClass('active')
      }
    }
  }

  var handleTabClick = function (e) {
    // e.preventDefault();
    linkWasClicked = true

    setTimeout(function () {
      linkWasClicked = false
    }, 1000)

    var $this = $(this)
    var section = $this.data('section')

    var text = $this.text()

    $('.js-collection-nav-toggle').not('.collection-nav--close').text(text)

    $this.addClass('active')
    $(settings.sidebarLink).not($this).removeClass('active')

    var $content = $(settings.mainSection + '[data-section="' + section + '"]')
    $content.addClass('active')
    $(settings.mainSection).not($content).removeClass('active')
  }

  var loadSectionFromHash = function () {
    if (window.location.hash) {
      var element = document.getElementById(window.location.hash.replace('#', ''))

      if (element) {
        var $el = $(element)

        if ($el.hasClass('js-accordion-group')) {
          $el.find('.js-accordion-title a').click()
        }

        $('html, body').animate(
          {
            scrollTop: $(element).offset().top - 70,
          },
          0
        )

        // element.scrollIntoView(true);
      }
    }
  }

  return { init: init }
})()

var sectionNumbers = (function () {
  var settings = {
    numbers: '.js-section-number',
  }

  var init = function () {
    if ($(settings.numbers).length === 0) return

    $(settings.numbers).each(function (index, el) {
      var numberText = '0' + (index + 1) + '.'
      $(el).text(numberText)
    })
  }

  return { init: init }
})()

let teamPagination = (function () {
  var settings = {
    teamMembersSection: '#team-members',
    aboutSection: '#shopify-section-about-team-blocks',
  }

  let init = function () {
    if (!$(settings.teamMembersSection).length) return

    $(document).on('click', '#team-members .page a, #team-members .prev a, #team-members .next a', getNextPage)
  }

  let getNextPage = function (e) {
    e.preventDefault()

    let $this = $(this)
    let href = $this.attr('href')

    let url = href + '&sections=about-team-blocks'

    $.ajax(url).then(function (response) {
      if (response && response['about-team-blocks']) {
        $(settings.aboutSection).replaceWith($(response['about-team-blocks']))
        $(settings.aboutSection).find('.will-animate').addClass('animate')
        scrollToTeamSection()
        history.replaceState({}, '', href)
      }
    })
  }

  let scrollToTeamSection = function () {
    $(settings.teamMembersSection)[0].scrollIntoView()
  }

  return {
    init,
  }
})()

// +++++++++++++++++++++
// Initialize all custom JS modules here
// +++++++++++++++++++++
var init = function () {
  accordion.init()
  sidebarPage.init()
  animations.init()
  sectionNumbers.init()
  teamPagination.init()
}

$(document).ready(init)
